import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import DynamicImage from "../../../atoms/DynamicImage";
import TextCta from "../../../atoms/CTA-Text/index";
import colors from "../../../../helpers/colors";
import Facebook from "../../../../resources/images/social-icons/facebook.svg";
import Linkedin from "../../../../resources/images/social-icons/linkedin.svg";
import Twitter from "../../../../resources/images/social-icons/twitter.svg";
import globalText from "../../../../helpers/globalText";
import addNoOpenerToAnchors from "../../../../helpers/addNoOpenerToAnchors";
import TableSection from './tableSection';
const Container = styled.div`
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "65%")};
  width: 100%;
`;

const Paragraphs = styled.div`
  margin-top: 50px;
`;

const Paragraph = styled.p`
  margin: 24px 0;
  color: ${colors.paragraphTextColor};
  font-size: 16px;

  a {
    color: ${colors.mvBlue};
    text-decoration: none;
    cursor: pointer;
    transition: 0.4s;

    :hover {
      color: ${colors.mvMediumTurqoiseBlue};
      transition: 0.4s;
      text-decoration: underline;
    }
  }

  & > b {
    font-weight: bold;
  }

  &:first-child {
    margin-top: 0 !important;
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 769px) {
    color: ${colors.mvDarkMediumGrey};
    line-height: 1.6;
    margin: 30px 0;
  }
`;

const ParagraphTitle = styled.h2`
  color: ${colors.mvDarkGrey};
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 15px;
`;

const ParagraphSubTitle = styled.h3`
  color: ${colors.mvDarkGrey};
  font-size: 17px;
  line-height: 1.5;
  margin-bottom: 15px;
`;

const ParagraphH4 = styled.h4`
  color: ${colors.mvDarkGrey};
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 15px;
`;

const UnorderedList = styled.ul`
  padding-left: 50px;
  margin: 24px 0;

  @media (max-width: 500px) {
    width: 100%;
    word-wrap: break-word;
  }
`;

const OrderedList = styled.ol`
  padding-left: 50px;
  margin: 24px 0;
`;

const ListItem = styled.li`
  color: ${colors.paragraphTextColor};
  font-size: 16px;

  a {
    color: ${colors.mvBlue};
    text-decoration: none;
    cursor: pointer;
    transition: 0.4s;

    :hover {
      color: ${colors.mvMediumTurqoiseBlue};
      transition: 0.4s;
      text-decoration: underline;
    }
  }

  @media (max-width: 769px) {
    color: ${colors.mvDarkMediumGrey};
    line-height: 1.3;
  }
`;

const BannerImage = styled(DynamicImage)`
  width: 100%;
  box-shadow: 0px 10px 20px ${colors.greyBoxShadow};
`;

const AuthorSection = styled.div`
  margin: 50px 0;
`;

const AuthorHeading = styled.div`
  color: ${colors.mvDarkGrey};
  font-weight: bold;
  font-size: 19px;
`;

const AuthorWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @media screen and (max-width: 640px) {
    flex-direction: column;
  }
`;

const AuthorImage = styled.div`
  width: 20%;
  margin-right: 30px;

  @media screen and (max-width: 1024px) {
    width: 25%;
  }

  @media screen and (max-width: 800px) {
    width: 30%;
  }

  @media screen and (max-width: 640px) {
    width: 175px;
  }
`;

const AuthorDescription = styled.div`
  width: 75%;
  color: ${colors.paragraphTextColor};
  font-size: 16px;
  line-height: 1.4;
  font-weight: 300;

  @media screen and (max-width: 1024px) {
    width: 70%;
  }

  @media screen and (max-width: 800px) {
    width: 65%;
  }

  @media (max-width: 769px) {
    color: ${colors.mvDarkMediumGrey};
    line-height: 1.6;
  }

  @media screen and (max-width: 640px) {
    width: auto;
    margin-top: 24px;
  }
`;

const ShareSection = styled.div`
  margin: 50px 0;
`;

const ShareHeading = styled.div`
  color: ${colors.mvDarkGrey};
  font-weight: bold;
  font-size: 19px;
`;

const ShareIcons = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

const ShareIconWrapper = styled.a`
  margin-left: 14px;
  cursor: pointer;

  &:first-child {
    margin-left: 0px;
  }
`;

const ImageFloatRight = styled.div`
  margin: 24px 0;
  float: right;
  margin-left: 24px;
  margin-bottom: 20px;
  max-width: 300px;

  @media (max-width: 500px) {
    width: 100%;
    max-width: none;
    margin: 30px auto;
  }
`;

const ImageFloatLeft = styled.div`
  margin: 24px 0;
  float: left;
  margin-right: 24px;
  margin-bottom: 20px;
  max-width: 300px;

  @media (max-width: 500px) {
    width: 100%;
    max-width: none;
    margin: 30px auto;
  }
`;

const FullWidthImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 28px;
  margin-bottom: 50px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const FullWidthObjItem = styled.div`
  width: 273px;
  text-align: center;

  a {
    color: ${colors.paragraphTextColor};
    text-decoration: underline;
    cursor: pointer;
    transition: 0.4s;

    :hover {
      color: ${colors.mvMediumTurqoiseBlue};
      transition: 0.4s;
      text-decoration: underline;
    }
  }
  img {
    width: 189px;
  }
`;

const QuoteBox = styled.div`
  box-shadow: 0px 10px 20px 0px #00000026;
  padding: 36px 31px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 50px;
  a {
    color: ${colors.mvBlue};
    text-decoration: none;
    cursor: pointer;
    transition: 0.4s;

    :hover {
      color: ${colors.mvMediumTurqoiseBlue};
      transition: 0.4s;
      text-decoration: underline;
    }
  }
`;

const QuoteBoxContainer = styled.div``;

const QuoteBoxTitle = styled.div`
  font-family: Roboto;
  font-weight: 900;
  font-size: 21px;
  line-height: 29px;
  letter-spacing: 0%;
`;

const QuoteBoxText = styled.div`
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
`;

const FullWidthImg = styled.div``;

const ContentImage = styled(DynamicImage)`
  width: 100%;
  margin: 24px 0;
`;

const ContentSection = ({
  url,
  paragraphs,
  authorImage,
  authorDescription,
  authorImageAlt,
  authorLink,
}) => {
  paragraphs.forEach(({ paragraphObj }) => {
    if (paragraphObj.paragraph && paragraphObj.paragraph.length) {
      paragraphObj.paragraph = addNoOpenerToAnchors(paragraphObj.paragraph);
    } else if (paragraphObj.bulletList && paragraphObj.bulletList.length) {
      paragraphObj.bulletList = paragraphObj.bulletList.map((listItem) =>
        addNoOpenerToAnchors(listItem)
      );
    } else if (paragraphObj.orderedList && paragraphObj.orderedList.length) {
      paragraphObj.orderedList = paragraphObj.orderedList.map((listItem) =>
        addNoOpenerToAnchors(listItem)
      );
    }
  });
  return (
    <Container>
      <Paragraphs>
        {paragraphs.map(({ paragraphObj }, index) => {
          if (
            paragraphObj.paragraphTitle &&
            paragraphObj.paragraphTitle.length
          ) {
            return (
              <ParagraphTitle
                dangerouslySetInnerHTML={{
                  __html: paragraphObj.paragraphTitle,
                }}
                id={paragraphObj.paragraphTitle}
                key={paragraphObj.paragraphTitle}
              />
            );
          }
          if (
            paragraphObj.paragraphSubTitle &&
            paragraphObj.paragraphSubTitle.length
          ) {
            return (
              <ParagraphSubTitle
                dangerouslySetInnerHTML={{
                  __html: paragraphObj.paragraphSubTitle,
                }}
                id={paragraphObj.paragraphSubTitle}
                key={paragraphObj.paragraphSubTitle}
              />
            );
          }
          if (paragraphObj.paragraphH4 && paragraphObj.paragraphH4.length) {
            return (
              <ParagraphH4
                dangerouslySetInnerHTML={{
                  __html: paragraphObj.paragraphH4,
                }}
                id={paragraphObj.paragraphH4}
                key={paragraphObj.paragraphH4}
              />
            );
          }
          if (paragraphObj.paragraph && paragraphObj.paragraph.length) {
            if (paragraphObj.blogImage) {
              if (paragraphObj.floatImage === "left") {
                return (
                  <>
                    <ImageFloatLeft key={paragraphObj.blogImage}>
                      <ContentImage
                        src={paragraphObj.blogImage}
                        alt={paragraphObj.blogImageAlt}
                      />
                    </ImageFloatLeft>
                    <Paragraph
                      dangerouslySetInnerHTML={{
                        __html: paragraphObj.paragraph,
                      }}
                      key={paragraphObj.paragraph}
                    />
                  </>
                );
              }

              if (paragraphObj.floatImage === "right") {
                return (
                  <>
                    <ImageFloatRight
                      key={paragraphObj.floatImage + Math.random()}
                    >
                      <ContentImage
                        src={paragraphObj.blogImage}
                        alt={paragraphObj.blogImageAlt}
                        className="image"
                      />
                    </ImageFloatRight>
                    <Paragraph
                      dangerouslySetInnerHTML={{
                        __html: paragraphObj.paragraph,
                      }}
                      key={paragraphObj.paragraph}
                    />
                  </>
                );
              }
            }

            return (
              <Paragraph
                dangerouslySetInnerHTML={{
                  __html: paragraphObj.paragraph,
                }}
                key={paragraphObj.paragraph}
              />
            );
          }

          if (paragraphObj.blogImage) {
            if (paragraphObj.blogImageLink) {
              return (
                <a href={paragraphObj.blogImageLink}>
                  <FullWidthImageContainer>
                    <ContentImage
                      src={paragraphObj.blogImage}
                      alt={paragraphObj.blogImageAlt}
                      key={paragraphObj.blogImageAlt}
                    />
                  </FullWidthImageContainer>
                </a>
              );
            } else {
              return (
                <FullWidthImageContainer>
                  <ContentImage
                    src={paragraphObj.blogImage}
                    alt={paragraphObj.blogImageAlt}
                    key={paragraphObj.blogImageAlt}
                  />
                </FullWidthImageContainer>
              );
            }
          }
          if (paragraphObj.showTable) {
            return (
              <TableSection />
            );
          }

          if (
            paragraphObj.fullWidthObj &&
            Array.isArray(paragraphObj.fullWidthObj.items) &&
            paragraphObj.fullWidthObj.items.length > 0
          ) {
            return (
              <FullWidthImageContainer key={index}>
                {paragraphObj.fullWidthObj.items.map((item, itemIndex) => (
                  <FullWidthObjItem key={itemIndex}>
                    <DynamicImage src={item.img} alt={item.imgAlt} />
                    <p
                      dangerouslySetInnerHTML={{
                        __html: item.text,
                      }}
                    ></p>
                  </FullWidthObjItem>
                ))}
              </FullWidthImageContainer>
            );
          }

          if (paragraphObj.quoteBox) {
            return (
              <QuoteBoxContainer key={index}>
                <QuoteBox>
                  <QuoteBoxTitle
                    dangerouslySetInnerHTML={{
                      __html: paragraphObj.quoteBox.quoteBoxTitle,
                    }}
                  ></QuoteBoxTitle>

                  <QuoteBoxText
                    dangerouslySetInnerHTML={{
                      __html: paragraphObj.quoteBox.quoteBoxText,
                    }}
                  ></QuoteBoxText>
                </QuoteBox>
              </QuoteBoxContainer>
            );
          }

          if (paragraphObj.bulletList && paragraphObj.bulletList.length) {
            return (
              <UnorderedList key={paragraphObj.bulletList}>
                {paragraphObj.bulletList.map((listItem) => {
                  return (
                    <ListItem
                      dangerouslySetInnerHTML={{
                        __html: listItem,
                      }}
                      key={listItem}
                    />
                  );
                })}
              </UnorderedList>
            );
          }

          if (paragraphObj.orderedList && paragraphObj.orderedList.length) {
            return (
              <OrderedList key={paragraphObj.orderedList}>
                {paragraphObj.orderedList.map((listItem) => {
                  return (
                    <ListItem
                      dangerouslySetInnerHTML={{
                        __html: listItem,
                      }}
                      key={listItem}
                    />
                  );
                })}
              </OrderedList>
            );
          }
          return null;
        })}
      </Paragraphs>
      <ShareSection>
        <ShareHeading>Share this:</ShareHeading>
        <ShareIcons>
          <ShareIconWrapper
            href={`https://www.facebook.com/sharer/sharer.php?u=www.motivosity.com/blog${url}/`}
            target="_blank"
            rel="noopener"
          >
            <img src={Facebook} alt={"Share via Facebook"} />
          </ShareIconWrapper>

          <ShareIconWrapper
            href={`https://www.linkedin.com/sharing/share-offsite/?url=https://motivosity.com/blog${url}/`}
            target="_blank"
            rel="noopener"
          >
            <img src={Linkedin} alt={"Share via Linkedin"} />
          </ShareIconWrapper>

          <ShareIconWrapper
            href={`https://twitter.com/intent/tweet?text=www.motivosity.com/blog${url}/`}
            target="_blank"
            rel="noopener"
          >
            <img src={Twitter} alt={"Share via Twitter"} />
          </ShareIconWrapper>
        </ShareIcons>
      </ShareSection>
      {authorImage || authorDescription ? (
        <AuthorSection>
          <AuthorHeading>About the Author</AuthorHeading>
          <AuthorWrapper>
            {authorImage ? (
              <AuthorImage>
                <DynamicImage src={authorImage} alt={authorImageAlt} />
              </AuthorImage>
            ) : null}
            {authorDescription ? (
              <>
                <AuthorDescription>
                  {authorDescription}
                  <br />
                  <br />
                  {authorLink ? (
                    <TextCta
                      ctaHref={authorLink + "/"}
                      ctaText={globalText.learnMore}
                    />
                  ) : null}
                </AuthorDescription>
              </>
            ) : null}
          </AuthorWrapper>
        </AuthorSection>
      ) : null}
    </Container>
  );
};

export default ContentSection;
